import { api } from "@/lib/api";

export function track(item, event, ref = "") {
  if (item?.source !== "vendor") return;
  api.post("/track", { listing_id: item.id, event, ref }).catch(() => {});
}
